'use strict';

import LoginController from './login.controller';

export default angular.module('leptonApp.login', [])
  .controller('LoginController', LoginController)
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/account/login/index.js